import { Category } from '../types/Category';

export const categories: Category = {
  food: { title: 'Alimentação', color: 'orange', expense: true },
  rent: { title: 'Aluguel', color: 'blue', expense: true },
  salary: { title: 'Salário', color: 'green', expense: false },
}